// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * Transport of one captured conversation.
 */
export enum SimulationFlowTransport {
  TCP = 0,
  UDP = 1,
}
